import { render, staticRenderFns } from "./DurationSuggestInput.vue?vue&type=template&id=4248db2b&scoped=true"
import script from "./DurationSuggestInput.vue?vue&type=script&lang=js"
export * from "./DurationSuggestInput.vue?vue&type=script&lang=js"
import style0 from "./DurationSuggestInput.vue?vue&type=style&index=0&id=4248db2b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4248db2b",
  null
  
)

export default component.exports